import api from 'Common/Client/Interceptor'

const ledgersService = {
  getReport: async (params) => {
    const response = await api.get(`/indv/reports/ledgers`, {
      params,
    })
    return response
  },

  downloadReport: async (params) => {
    const response = await api.get(`/indv/reports/ledgers/download`, {
      params,
      responseType: 'blob',
    })
    return response
  },
}

export default ledgersService